import { render, staticRenderFns } from "./live.vue?vue&type=template&id=6a4a983d&scoped=true&"
import script from "./live.vue?vue&type=script&lang=js&"
export * from "./live.vue?vue&type=script&lang=js&"
import style0 from "./live.vue?vue&type=style&index=0&id=6a4a983d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a4a983d",
  null
  
)

export default component.exports